import { phone } from "$lib/yup/util/phone-number"
import { taxNumberSchema } from "$lib/yup/util/tax-number"
import { TRUST_REVOCABILITY } from "@tastyworks/tastyworks-api"
import { dateISOString, isPastDate } from "@tastyworks/tastyworks-api/validate"
import { boolean, object, string, type InferType } from "yup"
import { addressSchema } from "../address"

export const trustBasicsSchema = object({
  trustName: string().required(),
  dateOfTrustCreation: dateISOString()
    .required()
    .test(isPastDate({ allowToday: true })),
  taxNumber: taxNumberSchema,
  phoneNumber: phone().required(),
})

export const primaryTrustAddressSchema = object({
  physicalAddress: addressSchema,
})

export const trustSameMailingAddressSchema = object({
  mailingAddressSameAsPrimary: boolean().required(),
})

export const trustMailingAddressDetailsSchema = object({
  mailingAddress: addressSchema,
})

const mailingAddressSchema = addressSchema.when(
  ["mailingAddressSameAsPrimary"],
  {
    is: false,
    then: (schema) => schema.required(),
    otherwise: (schema) => schema.optional().default(undefined).nullable(),
  }
)

export const trustMailingAddressSchema = object({
  mailingAddressSameAsPrimary: boolean().required(),
  mailingAddress: mailingAddressSchema,
})

export const trustRevocabilitySchema = object({
  trustRevocability: string()
    .oneOf(Object.values(TRUST_REVOCABILITY))
    .required(),
})

export const trustInformationSchema = object({
  trustBasics: trustBasicsSchema,
  trustPrimaryAddress: primaryTrustAddressSchema,
  trustSameMailingAddress: trustSameMailingAddressSchema,
  trustMailingAddressDetails: trustMailingAddressDetailsSchema,
  trustRevocability: trustRevocabilitySchema,
})

export type TrustPrimaryAddressData = InferType<
  typeof primaryTrustAddressSchema
>
